'use strict';

var Cleave = require('cleave.js').default;

module.exports = {
    handleCreditCardNumber: function (cardFieldSelector, cardTypeSelector) {
        var cleave = new Cleave(cardFieldSelector, {
            creditCard: true,
            onCreditCardTypeChanged: function (type) {
                var creditCardTypes = {
                    visa: 'Visa',
                    mastercard: 'Master Card',
                    amex: 'Amex',
                    discover: 'Discover',
                    unknown: 'Unknown'
                };

                var cardType = creditCardTypes[Object.keys(creditCardTypes).indexOf(type) > -1
                    ? type
                    : 'unknown'];
                $(cardTypeSelector).val(cardType);
                $('.card-number-wrapper').attr('data-type', type);
                if (type === 'visa' || type === 'mastercard' || type === 'discover') {
                    $('#securityCode').attr('maxlength', 3);
                } else {
                    $('#securityCode').attr('maxlength', 4);
                }
            }
        });

        $(cardFieldSelector).data('cleave', cleave);
    },

    serializeData: function (form) {
        var serializedArray = form.serializeArray();

        serializedArray.forEach(function (item) {
            if (item.name.indexOf('cardNumber') > -1) {
                item.value = $('#cardNumber').data('cleave').getRawValue(); // eslint-disable-line
            }
        });

        return $.param(serializedArray);
    },

    numericCCVNumber: function (input) {
        $(input).toArray().forEach(function (field) {
            var cleave = new Cleave(field, {
                blocks: [4],
                numericOnly: true
            });
            $(field).data('cleave', cleave);
        });
    },

    formatPhoneNumber: function (input) {
        var cleave = $(input).data('cleave');

        if (cleave) {
            cleave.destroy();
        }

        cleave = new Cleave(input, {
            numericOnly: true,
            blocks: [0, 3, 3, 4],
            delimiters: ['(', ') ', '-']
        });

        $(input).data('cleave', cleave);
    },

    validatePhoneNumber: function (input) {
        var value = $(input).data('cleave') && $(input).data('cleave').getRawValue();
        if (value === undefined) {
            value = $(input).val().replace(/[\(\)\-\s]/g, '');
        }
        var id = '#' + $(input).attr("id");
        var invalidMsgContainer = $(input).closest('.form-group').find('.invalid-feedback');
        var isCountryUS = $(input).parents('form').find('select.js-country').val() === "US";

        $(id)[0].checkValidity();

        if ($(id)[0].checkValidity()) {
            $(id).removeClass('is-invalid');
        }

        if ((value && (value.length < 10 || value.length > 20)) || (isCountryUS && /^[2-9][0-9]{9}$/.test(value) == false)) {
            $(id)[0].setCustomValidity('invalid characters');
            $(id).addClass('alt-error is-invalid');
            invalidMsgContainer.text('Please enter a valid phone number');
            return false;
        } else {
            $(id).removeClass('alt-error');
        }

        return true;
    },
    
    removePhoneFormatting: function(input) {
        var cleave = $(input).data('cleave');

        if (cleave) {
            cleave.destroy();
        }

        cleave = new Cleave(input, {
            numericOnly: true,
            blocks: [20]
        });

        $(input).data('cleave', cleave);
    }
};
